import { Component, OnInit } from '@angular/core';
import { RouterModule } from '@angular/router';
import { FGBSharedModule } from '@fgb/portal-component-library/src/lib/shared';

@Component({
  selector: 'fgb-game-nav',
  templateUrl: './game-nav.component.html',
  styleUrls: ['./game-nav.component.scss'],
  standalone: true,
  imports: [RouterModule, FGBSharedModule],
})
export class GameNavComponent implements OnInit {
  constructor() {}

  ngOnInit() {}
}
